import { Button } from 'antd';
import styled from 'styled-components';

export const RangePickerButtonContainer = styled(Button)`
	border: 1px solid ${({ theme }) => theme.border};
`;
